<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12 card">
        <div class="container-fluid card-body">
          <div class="d-flex justify-content-between mb-2">
          <span><router-link :to="{ path: '/testresultreports'}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-arrow-left"></i> Back</router-link></span>
          <span><router-link :to="{ path: '/printtestreport',  query: { id: this.$route.query.id }}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-printer"></i> Print</router-link></span>
          </div>
              <div class="row d-flex justify-content-between">
                <div class="col-5">
                    <img class="img-rounded" src="@/assets/images/sick.png" height="50px" /><br>
                    <table class="table" density="compact" style="color:black">
                    <tr><td>Full Name: </td><td class="h5"> {{ patientData.name }}</td></tr>
                    <tr><td>Gender: </td><td class="h6"> {{ patientData.gender }} </td> </tr>
                    <tr><td> Telephone: </td><td class="h6"> 0{{ patientData.telephone }} </td></tr>
                    <tr><td> Age: </td><td class="h6"> {{ getAge(patientData.date_of_birth) }} yrs </td></tr>
                    <tr><td> Address: </td><td class="h6"> {{ patientData.address }} </td></tr>
                  </table>
                </div>
                <div class="col-4">
                  <span v-if="userData.logo!=0"><img :src="getLogo(userData.logo)" height="50"/></span>
                    <span v-else><img src="@/assets/images/logo.png" height="50"/></span>
                    
                    <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
                    <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
                    <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br>
                    <span style="color:black;font-size:13px">Email : {{ userData.email }}</span><br>
                    <span style="color:black;font-size:13px">Website : {{ userData.website }}</span><br>
                </div>
              </div>
              <h6 class="mt-2 text-center">Date : {{ visit_date }}</h6>
              <h4 class="mt-2 text-center text-decoration-underline">Laboratory Results</h4>

              <div class="my-2">
                <table class="table table-sm mt-2" style="color: black;" density="compact">
                  <thead><tr><th>Test</th><th>Sample</th><th>Results</th></tr></thead>
                  <tbody>
                    <tr v-for="item in patientTest" :key="item.id">
                      <td>{{ item.test.name }} <br><b class="small">{{ commas(item.test.serviceprice) }} </b></td>
                      <td><span v-html="item.sample.name"></span></td>
                      <td><span v-html="item.result"></span></td>
                    </tr> 
                  </tbody>
                </table>
              </div> 
                            
            </div>
      </div>
    </div>
    
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Patient Lab Report",
    meta: [{name: "description",content: appConfig.description,},],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Patient Lab Report",
      items: [{text: "Dashboard",to: "/",},{text: "Patient Lab Report",active: true,},],
      patientTest:[],
      patientData:[],
      visit_date:new Date().toLocaleDateString('fr-CA'),
    };
  },
  created() {
    this.showlabresults();
    this.showpatientinfo();
  },
  methods: {
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    getLogo(name){
        let url = axios.defaults.baseURL;
        let imagelink = (url).slice(0,-3)+"logos/"+name;
        return imagelink;
      },
      async showpatientinfo(){
      this.visit_id=this.$route.query.id;
      let formData = new FormData();
      formData.append("visit_id", this.visit_id);
      let url = "/findpatientlabinfo";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.patientData=response.data.patient;
        }
      })
    },
    getAge(dateString){
      let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => {birth.setDate(now.getDate());birth.setMonth(now.getMonth()); return birth.getTime()})() < birth.getTime()) ? 0 : 1;
      return now.getFullYear() - birth.getFullYear() - beforeBirth;
    },
    async showlabresults(){
      this.visit_id=this.$route.query.id;
      let url = `/labpatientprofile/${this.visit_id}`;
      await axios.get(url).then((response) => {
        this.patientTest = response.data.results;
      });
    },
  },
};
</script>